import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import {HBox, VBox} from '../../../../components/Box';
import {InvoiceDirectionLabel} from "./labels/invoiceDirectionLabel";
import {InvoiceSubjectTypeLabel} from "./labels/invoiceSubjectTypeLabel";
import {InvoiceTypeLabel} from "./labels/invoiceTypeLabel";
import {getErrorStep} from "../../../Invoices/helpers";

const Container = styled.div`
  .formField {
    width: 100%;
    .form-controlField {
      > div {
        width: 100%;
      }
    }
  }
`;

const ERROR = styled.div`
  color: red;
  margin-top: 20px;
`;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class BASE_INVOICE_CELLComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
  }

  get invoice() {
    return this.props.cell.invoice ?? {};
  }

  get error() {
    const errorStep = getErrorStep(this.invoice);
    return errorStep?.error;
  }

  get errorStepName() {
    return getErrorStep(this.invoice)?.stepName;
  }

  onClickOpen() {
    this.to(`/invoices/${this.invoice.id}`, true);
  }
  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={`Invoice ${this.invoice.id}`}>
        <HBox>
          <InvoiceDirectionLabel direction={this.invoice.direction}>
            {this.invoice.direction}
          </InvoiceDirectionLabel>
          <InvoiceSubjectTypeLabel type={this.invoice.subjectType}>
            {this.invoice.subjectType}
          </InvoiceSubjectTypeLabel>
          <InvoiceTypeLabel type={this.invoice.type}>
            {this.invoice.type}
          </InvoiceTypeLabel>
        </HBox>
        <HBox>
          <Button onClick={this.onClickOpen.bind(this)}>Open invoice</Button>
        </HBox>
        {this.error && <ERROR>
          <p>Failed to make the invoice {this.errorStepName}</p>
          <p>Error:</p>
          <p>{this.error}</p>
        </ERROR>}
      </Modal>
    );
  }

  render() {
    return (
      <Cell>
        <Container>
            <VBox>
              {this.invoice.id}
              <InvoiceDirectionLabel direction={this.invoice.direction}>
                {this.invoice.direction}
              </InvoiceDirectionLabel>
              <InvoiceSubjectTypeLabel type={this.invoice.subjectType}>
                {this.invoice.subjectType}
              </InvoiceSubjectTypeLabel>
              <InvoiceTypeLabel type={this.invoice.type}>
                {this.invoice.type}
              </InvoiceTypeLabel>
            </VBox>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

BASE_INVOICE_CELLComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.invoice.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    // confirm(vehicle_id, regplate_code) {
    //   dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    // },
    // print() {
    //   dispatch(setVehicleProperty(ownProps.cell.vehicle.id, 'label_printer_queue', '1'));
    // },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BASE_INVOICE_CELL = compose(
  withConnect,
  withRouter,
)(BASE_INVOICE_CELLComp);
